<ngx-loading [show]="fonctionsService.loading"></ngx-loading>
 @if (shouldShowOldNavBars()) {
  <div class="old-theme">
    @if (utilisateurService.isInitialize()) {
      <div class="sidenav">
        <app-nav-bar-left></app-nav-bar-left>
      </div>
      <div class="main sidenav-displayed">
        <app-nav-bar-top></app-nav-bar-top>
        <div id="contenu">
          <router-outlet></router-outlet>
        </div>
      </div>
    }@else {
      <ngx-loading [show]="true"></ngx-loading>
    }

    <div id="toast-success">
      <div class="toast-img"><i class="fas fa-check"></i></div>
      <div class="toast-desc">{{'GLOBAL.MESSAGE_REUSSITE' | translate}}</div>
    </div>

    <div id="toast-success-delete">
      <div class="toast-img"><i class="fas fa-check"></i></div>
      <div class="toast-desc">{{'GLOBAL.SUPPRESSION_REUSSIE' | translate}}</div>
    </div>

    <div id="toast-error">
      <div class="toast-img"><i class="fas fa-times"></i></div>
      <div class="toast-desc">{{'GLOBAL.MESSAGE_ERREUR' | translate}}</div>
    </div>

    <div id="toast-error-personnalized">
      <div class="toast-img"><i class="fas fa-times"></i></div>
      <div class="toast-desc" id="desc-personnalized"></div>
    </div>

    <!-- Satisfaction Survey Component -->
    <app-satisfaction-survey></app-satisfaction-survey>
  </div>
 }
 @else {
  <div class="main-full-width new-theme">
 
    <!-- Navbar — fixe en haut -->
    <app-nav-bar></app-nav-bar>
    
    <div [class]="device.device() === 'desktop' ? 'desktop-body' : 'mobile-body'">
  
      <!-- Nav left — structure fixe, contenu injecté par chaque page via NavLeftService -->
      @if (!isProfilePage()) {
        <app-nav-left [hidden]="!device.isDesktop() && !navLeft.mobileNavVisible()"></app-nav-left>
      }
  
      <!-- Contenu de la page active -->
      <main class="app-content">
        @if (!isProfilePage()) {
          <app-page-bar></app-page-bar>
        }
        <router-outlet></router-outlet>
      </main>
  
    </div>
  
  </div>
}